<template>
  <div class="guide">
    <b-container class="mb-4">
      <b-row>
        <b-col>
          <b-card class="text-center d-flex flex-column justify-content-center">
            <b-card-title class="mb-1">
              {{ $t("Getting Started with DIKO") }}
            </b-card-title>
            <b-card-text class="mb-0">
              {{ $t("Follow these short steps to complete your first DIKO workflow.") }}
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="match-height mb-2">
        <b-col
          v-for="(item, index) in starterVideos"
          :key="`starter-${item.title}`"
          md="6"
          lg="3"
          class="mb-4"
        >
          <b-card class="h-100 text-center">
            <div class="tour-step-number mb-1">
              {{ index + 1 }}
            </div>
            <h4 class="mb-3">
              {{ item.title }}
            </h4>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                :src="item.url"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
      <h2 class="text-center mb-3">
        {{ $t("All Guide Videos") }}
      </h2>
      <b-row>
        <b-col
          v-for="item in otherVideos"
          :key="item.title"
          md="6"
          lg="4"
          class="mb-4"
        >
          <b-card class="h-100 text-center">
            <h4 class="mb-3">
              {{ item.title }}
            </h4>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                :src="item.url"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BCardText, BCardTitle, BCol, BContainer, BRow,
} from 'bootstrap-vue'

export default {
  name: 'Guide',
  components: {
    BCard,
    BCardBody,
    BCardText,
    BCardTitle,
    BCol,
    BContainer,
    BRow,
  },
  data() {
    return {
      video: [
        {
          title: 'Hızlı Tur',
          url: 'https://www.youtube.com/embed/ZsBHy76yfc4',
        },
        {
          title: 'Danışan Ekle',
          url: 'https://www.youtube.com/embed/RPNxORM2a7I',
        },
        {
          title: 'GBT Uygula',
          url: 'https://www.youtube.com/embed/gtxo1TfTmRY',
        },
        {
          title: 'GBT Dikkat Bölümü',
          url: 'https://www.youtube.com/embed/f36VwrmoxQw',
        },
        {
          title: 'GBT Konsantrasyon Bölümü',
          url: 'https://www.youtube.com/embed/CXyop9x9UBU',
        },
        {
          title: 'GBT Mantık Bölümü',
          url: 'https://www.youtube.com/embed/OZIUMSOniCE',
        },
        {
          title: 'GBT Hafıza Bölümü',
          url: 'https://www.youtube.com/embed/dScpsbukOi0',
        },
        {
          title: 'GBT Sonuçlar',
          url: 'https://www.youtube.com/embed/pRsThBZYc3w',
        },
        {
          title: 'Set İşlemleri',
          url: 'https://www.youtube.com/embed/3s0mAMxuD2U',
        },
        {
          title: 'Veri Girişi',
          url: 'https://www.youtube.com/embed/__UmnDFYN8M',
        },
        {
          title: 'Danışan Sayfası',
          url: 'https://www.youtube.com/embed/h9zzhLukiIM',
        },
        {
          title: 'Online Seans',
          url: 'https://www.youtube.com/embed/hTBsMEFXeIE',
        },
        {
          title: 'Test ve Grafik Yorumlama',
          url: 'https://www.youtube.com/embed/lf24ZiL2N0c',
        },
        {
          title: 'Anasayfa',
          url: 'https://www.youtube.com/embed/dojKj6AxH1I',
        },
        {
          title: 'Takvim',
          url: 'https://www.youtube.com/embed/gkuI-NQYGyE',
        },
        {
          title: 'Danışanlar',
          url: 'https://www.youtube.com/embed/C4JYduNsLSs',
        },
        {
          title: 'Veli Takip Sistemi',
          url: 'https://www.youtube.com/embed/8x0B1-m_aQI',
        },
        {
          title: 'Hesap Ayarları',
          url: 'https://www.youtube.com/embed/Q5kglitPgiw',
        },
        {
          title: 'Hesap Bilgileriniz',
          url: 'https://www.youtube.com/embed/UcRXTAO9y2I',
        },
        {
          title: 'Şifre Değiştirme',
          url: 'https://www.youtube.com/embed/EkURbffSKuc',
        },
        {
          title: 'Kurumsal Bilgiler',
          url: 'https://www.youtube.com/embed/VbBG6v29UPI',
        },
        {
          title: 'Bilgi Bankası',
          url: 'https://www.youtube.com/embed/Royk33ulQ1A',
        },
        {
          title: 'Formlar',
          url: 'https://www.youtube.com/embed/l_7BsMExB14',
        },
      ],
    }
  },
  computed: {
    starterVideos() {
      const titles = ['Hızlı Tur', 'Danışan Ekle', 'GBT Uygula', 'GBT Sonuçlar']
      return titles.map(title => this.video.find(item => item.title === title)).filter(Boolean)
    },
    otherVideos() {
      const starterTitles = new Set(this.starterVideos.map(item => item.title))
      return this.video.filter(item => !starterTitles.has(item.title))
    },
  },
}
</script>
<style scoped>
.tour-step-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: #de39a5;
    color: #fff;
    font-weight: 700;
}
</style>
